import {
  getUserLenderID,
  isLenderAxis,
  LENDER_IDs
} from "src/shared/utils/Global";
import { useDocument } from "./DocumentComponentContext";

const DocumentInformation = () => {
  const { document } = useDocument();
  const isAxis = isLenderAxis();

  const isLenderMFLLAP = (): boolean =>
    getUserLenderID() === LENDER_IDs.MFL_LAP;

  const isMFLLAP = isLenderMFLLAP();
  const title =
    isAxis || isMFLLAP
      ? document.displayNameInConfig?.replaceAll("_", " ") ||
        document.documentName?.replaceAll("_", " ")
      : document.documentType?.replaceAll("_", " ");

  const fileName = document.isBackImage
    ? document.documentUrl?.backFileName
    : document.documentUrl?.frontFileName;

  const displayFileName =
    fileName || document.documentName?.replaceAll("_", " ");

  return (
    <div className="py-1 flex flex-col">
      <div className="flex justify-between items-center">
        <span
          className={`${document.isCompact ? "text-[9px]" : "text-xs"} mr-4 text-gray-700 truncate flex-1`}
          title={displayFileName}
        >
          {displayFileName}
        </span>

        {document?.createdAt && (
          <span
            className={`${document.isCompact ? "text-[9px]" : "text-xs"} text-gray-500 whitespace-nowrap`}
          >
            {typeof document.createdAt === "string"
              ? document.createdAt.replace(/[T\s]/, " | ").split(".")[0]
              : document.createdAt}
          </span>
        )}
      </div>

      <div className="flex justify-between items-center mt-1">
        <span
          className={`font-medium ${document.isCompact ? "text-[10px] leading-tight" : "text-xs"} break-all tracking-wide`}
        >
          {title}
        </span>
      </div>

      {document?.password && (
        <div className="flex justify-between items-center">
          <span
            className={`${document.isCompact ? "text-[10px]" : "text-sm"} mr-4 font-medium text-gray-700`}
          >
            Password:
          </span>
          <span
            className={`${document.isCompact ? "text-[9px]" : "text-xs"} text-gray-500 break-all`}
          >
            {document?.password}
          </span>
        </div>
      )}

      {/* {document?.createdAt && (
        <div className="flex justify-between items-center">
          <span className="text-sm mr-4 font-medium text-gray-700">
            Created At
          </span>
          <span className="text-xs text-gray-500 break-all">
            {document?.createdAt}
          </span>
        </div>
      )} */}
    </div>
  );
};

export default DocumentInformation;
